/* eslint-disable import/prefer-default-export */
import { BrandRetailerStatus } from "__generated__/gql/graphql";

export const BRAND_RETAILER_STATUS_LABELS: Record<BrandRetailerStatus, string> =
  {
    [BrandRetailerStatus.PROSPECTIVE]: "Prospective",
    [BrandRetailerStatus.APPROVED]: "Approved",
    [BrandRetailerStatus.CURRENT]: "Current",
    [BrandRetailerStatus.INACTIVE]: "Inactive",
  };
